import React from 'react';
import { Heart } from 'lucide-react';
export function ProofSection() {
  return <section className="py-16 md:py-20 px-4 bg-white border-y border-gold/20" data-id="element-204">
      <div className="max-w-4xl mx-auto text-center" data-id="element-205">
        <Heart className="w-12 h-12 text-burgundy mx-auto mb-6 opacity-80" data-id="element-206" />
        <p className="text-2xl md:text-3xl font-heading text-burgundy leading-relaxed italic mb-8" data-id="element-207">
          "En solo 7 días, usted sentirá una paz mental que no recordaba."
        </p>
        <p className="text-xl text-charcoal-light max-w-3xl mx-auto" data-id="element-208">
          Pasará de la preocupación de "qué pasará si pierdo mi teléfono" a la
          seguridad total de saber que su familia tiene todo el control
          necesario para honrar sus deseos, sin dramas técnicos.
        </p>
      </div>
    </section>;
}